/**
 * reCAPTCHA v3 (invisible). Carga el script una sola vez; el badge aparece en esquina.
 * Uso: loadRecaptchaScript().then(() => ...), luego getRecaptchaToken(siteKey, action).
 */
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export function getSiteKey() {
  return RECAPTCHA_SITE_KEY;
}

export function loadRecaptchaScript() {
  return new Promise((resolve) => {
    if (!RECAPTCHA_SITE_KEY) {
      resolve();
      return;
    }
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(resolve);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(resolve);
    };
    document.head.appendChild(script);
  });
}

export async function getRecaptchaToken(action) {
  if (!RECAPTCHA_SITE_KEY || !window.grecaptcha) return null;
  return window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
}
